import {
  ContactsApiClientInterface,
  ContactsApiClientModel,
  ContactsApiClientUrlsInterface,
  // ContactsApiClientOptions,
} from '../../../models/api-client/models';

const urls: ContactsApiClientUrlsInterface = {
  createContact: 'http://localhost:3050/contacts',
  fetchContacts: 'http://localhost:3050/contacts',
};

const ContactsApiClient: ContactsApiClientInterface =
  new ContactsApiClientModel({
    urls,
  });
// export our instance
export {ContactsApiClient};
